import { useSyncExternalStore } from "react";

export interface ToastOptions {
  message: string;
  severity?: "info" | "error" | "success";
  durationMs?: number;
}

interface ToastEntry extends ToastOptions {
  id: number;
}

let nextId = 1;
let queue: ToastEntry[] = [];
const listeners = new Set<() => void>();

function notify(): void {
  for (const cb of listeners) cb();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

function getSnapshot(): ToastEntry[] {
  return queue;
}

export function showToast(opts: ToastOptions): void {
  const entry: ToastEntry = { ...opts, id: nextId++ };
  queue = [...queue, entry];
  notify();
  const ms = opts.durationMs ?? 3000;
  window.setTimeout(() => {
    queue = queue.filter((e) => e.id !== entry.id);
    notify();
  }, ms);
}

export function Toaster() {
  const toasts = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  if (toasts.length === 0) return null;
  return (
    <div
      data-testid="toaster"
      className="pointer-events-none fixed inset-x-0 bottom-24 z-50 flex flex-col items-center gap-2 px-4"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          data-toast-severity={t.severity ?? "info"}
          className="rounded-full px-4 py-2 text-sm shadow-lg"
          style={{
            background: "#1A1620",
            color: "#FFFCF8",
            borderLeft:
              t.severity === "error" ? "3px solid #A05A38" : "3px solid transparent",
          }}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
